import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Custom hook to access group logos from Redux store
 * @returns {Array<string>} Array of logo paths
 */
export const useGroupLogos = (showLabel = false) => {
	const { logoPaths, franchiseList } = useSelector((state) => ({
		logoPaths: state.groupLogos?.logoPaths || [],
		franchiseList: state.franchiseList?.franchiseList || []
	}));

	return useMemo(() => {
		if (!franchiseList.length) return [];

		return franchiseList.map((franchiseName) => {
			// Convert spaces to hyphens and lowercase for URL path matching
			const franchiseSlug = franchiseName
				.toLowerCase()
				.replace(/\s+/g, '-');

			// Find matching logo path
			const matchingLogo = logoPaths.find((path) =>
				path.toLowerCase().includes(`/${franchiseSlug}/`)
			);

			return {
				brand: {
					name: franchiseName,
					brandLogoImgUrl: matchingLogo || '',
					href: `/inventory/${franchiseSlug}.htm`,
					showLabel: !!showLabel
				}
			};
		});
	}, [logoPaths, franchiseList, showLabel]);
};
